var exports = {
  "H": "indexCard__54aTBv",
};

module.exports = exports;
